import { FunctionField } from 'react-admin';

/** Format a cents amount as USD, e.g. 320 → "$3.20". */
const formatCents = (cents: unknown): string => `$${(((cents as number) ?? 0) / 100).toFixed(2)}`;

/**
 * A react-admin field that renders a cents-valued `source` as USD. Works in both a Datagrid
 * column and a SimpleShowLayout. Used for money fields stored in cents (account balance, ad spend)
 * — budget is stored in dollars, so use a plain NumberField with currency options for that.
 */
export const CentsField = ({ source, label }: { source: string; label?: string }) => (
  <FunctionField
    source={source}
    label={label}
    render={(record: Record<string, unknown>) => formatCents(record?.[source])}
  />
);
